module.exports = __webpack_public_path__ + "img/KM.5946bdc7.svg";